import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Masthead from './Masthead';
import Footer from './Footer';

export default function Layout() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 640);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Masthead />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />

      <button
        type="button"
        onClick={scrollTop}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-none transition-all hover:bg-primary-600 ${
          showTop ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
        }`}
      >
        <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
      </button>
    </div>
  );
}